"use strict";

Shopify.theme.jsFeaturedBlog = {

  init: function init($section) {
    this.createSlider();

  },
  createSlider: function createSlider() {
    
    var $featuredBlogSlider = $('.featured-blog-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      fade: false,
      infinite: false,
      rows: 0/*,
      centerMode:true*/

      ,responsive: [
        {
          breakpoint: 798,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: true/*,
            centerMode:true*/
          }
        }
      ]

    });

  },
  blockSelect: function blockSelect($section, blockId) {
    var $featuredBlogSlider = $section.find('.featured-blog-slider');
    var slideIndex = $('#featured-blog-section-' + blockId).data('item-index');
    $featuredBlogSlider.slick('slickGoTo', slideIndex, true, true);
  },
  unload: function unload($section) {
    var $slider = $section.find('.featured-blog-slider');
    $slider.slick('unslick');
  }

};


window.addEventListener('load', function () {
  Shopify.theme.jsFeaturedBlog.init($('.jsFeaturedBlog'));
}, false);


 



